export default "__VITE_ASSET__DO0wT07C__"